import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import moment from 'moment'

import Link from '../utils/link'
import usePostsQuery from '../hooks/use-posts-query';

const LatestMedia = ({ title }) => {
  const { allWpPost } = usePostsQuery();

  if (allWpPost.nodes.length === 0) {
    return null;
  }

  const post = allWpPost.nodes[0];

  return (
    <section className="latest-media">
      <Link to={post.uri} className="latest-media__inner">
        <GatsbyImage image={getImage(post?.featuredImage?.node?.localFile)} alt={title} />
        <h2>{ post.title }</h2>
        <p>{ moment(post.date).format('ddd do MMM') }</p>
      </Link>
    </section>
  );
}

LatestMedia.defaultProps = {
  title: ``,
};

export default LatestMedia;